<template>
  <v-row dense>
    <v-col cols="12">
      <v-sheet class="d-flex align-center mb-4 justify-space-between flex-column flex-sm-row"
        :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'">
        <div class="title">
          <v-img class="mr-3" max-width="17" src="@/assets/Dashboard/bar.svg"></v-img>
          <span>Important Business Data</span>
        </div>

        <v-btn v-if="$canRoute('create-new-user-account') === 1" small tile elevation="0" to="/create-new-user-account"
          class="ma-0 text-capitalize btn-account" color="greenMain">
          Add New User
        </v-btn>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import { AUTHENTICATION__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      logoutCheckInterval: null,
      loginTime: null,
    };
  },

  beforeDestroy() {
    clearInterval(this.logoutCheckInterval);
  },

  computed: {
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("authentication", [AUTHENTICATION__ACTIONS.LOGOUT]),
    async checkLogout() {
      if (this.loginTime) {
        const moment1 = moment(parseInt(this.loginTime));
        const moment2 = moment(new Date().getTime());
        const differenceInMinutes = moment2.diff(moment1, "minutes");

        if (differenceInMinutes >= 720) {
          //12hours
          clearInterval(this.logoutCheckInterval);
          await this[AUTHENTICATION__ACTIONS.LOGOUT]();
        } else {
          // console.log("The difference is not 1 minute.");
        }
      }
    },
  },

  async mounted() {
    this.loginTime = localStorage.getItem("loginTime");
    this.checkLogout();
    this.logoutCheckInterval = setInterval(() => this.checkLogout(), 1000);
  },
};
</script>
